import UrlHashHandler from './urlHashHandle'
import emitter from './emitter'
import UrlHandler from '@/utils/urlHandler'
import { getLocale } from '@/utils/locale'

const TYPES = {
  LOGIN: 'login',
  LOGOUT: 'logout',
}

// 提供util判断是否为H5
const isH5 = document.body.clientWidth <= 768

class PassportMonitor {
  constructor() {
    this.beforeLoginFnList = []
    this.afterLoginFnList = []
    this.beforeLogoutFnList = []
    this.afterLogoutFnList = []
    this.loginFnList = []
    this.logoutFnList = []
    this.loadedFnList = []
  }

  login() {
    this.beforeLogin()
    if (isH5) {
      const urlHashHandler = new UrlHashHandler(location.href)
      urlHashHandler.set(TYPES.LOGIN)
      location.href = urlHashHandler.getUrl()
    }
    this._login()
  }

  get _homeHref() {
    const urlHandler = new UrlHandler(location.href)
    const targetPath = `${getLocale()}/food/address/`
    urlHandler.set({ pathname: targetPath })
    return urlHandler.getUrl()
  }

  logout() {
    this.beforeLogout()
    if (isH5) {
      const urlHashHandler = new UrlHashHandler(this._homeHref)
      urlHashHandler.set(TYPES.LOGOUT)
      location.href = urlHashHandler.getUrl()
    }
    this._logout()
  }

  _existFn(list, fn) {
    return list.indexOf(fn) !== -1
  }

  registerLogin(fn) {
    if (this._existFn(this.loginFnList, fn)) {
      return
    }
    this.loginFnList.push(fn)
  }

  registerLogout(fn) {
    if (this._existFn(this.logoutFnList, fn)) {
      return
    }
    this.logoutFnList.push(fn)
  }

  registerLoaded(fn) {
    if (this._existFn(this.loadedFnList, fn)) {
      return
    }
    this.loadedFnList.push(fn)
  }

  registerBeforeLogin(fn) {
    if (this._existFn(this.beforeLoginFnList, fn)) {
      return
    }
    this.beforeLoginFnList.push(fn)
  }

  registerAfterLogin(fn) {
    if (this._existFn(this.afterLoginFnList, fn)) {
      return
    }
    this.afterLoginFnList.push(fn)
  }

  registerBeforeLogout(fn) {
    if (this._existFn(this.beforeLogoutFnList, fn)) {
      return
    }
    this.beforeLogoutFnList.push(fn)
  }

  registerAfterLogout(fn) {
    if (this._existFn(this.afterLogoutFnList, fn)) {
      return
    }
    this.afterLogoutFnList.push(fn)
  }

  _login() {
    this.loginFnList.forEach(fn => {
      fn()
    })
  }

  _logout() {
    this.logoutFnList.forEach(fn => {
      fn()
    })
  }

  beforeLogin() {
    this.beforeLoginFnList.forEach(fn => {
      fn()
    })
  }

  afterLogin(res) {
    this.afterLoginFnList.forEach(fn => {
      fn(res)
    })
  }

  beforeLogout() {
    this.beforeLogoutFnList.forEach(fn => {
      fn()
    })
  }

  afterLogout() {
    this.afterLogoutFnList.forEach(fn => {
      fn()
    })
  }

  loaded() {
    this.loadedFnList.forEach(fn => {
      fn()
    })
  }

  monitor() {
    const urlHashHandler = new UrlHashHandler(location.href)
    if (urlHashHandler.exist()) {
      const type = urlHashHandler.get()
      urlHashHandler.clear()
      // 直接设置，会触发浏览器刷新
      // location.href = urlHashHandler.getUrl();
      // 会在URL末尾加个#；这里有个副作用，会把原来的URL中的hash丢掉，不过问题不大
      location.hash = ''
      /**
       * H5有自己的监听登陆后的monitorH5，公用这个会导致H5登陆重复刷新
       *
       * 公用逻辑： clear及loaded是pc和H5在刷新的时候的公用逻辑，都需要用
       * 但是H5的登陆/登出的事件会在monitorH5中施行，时机在passport的回调之后才会触发
       * 这里的登陆/登出的事件只给PC用，因为PC的登陆登出事件是跳转页面做的
       *
       */
      if (!isH5) {
        if (type === TYPES.LOGIN) {
          this.afterLogin()
        } else {
          this.afterLogout()
        }
      }
    } else {
      console.log('=========== 普通刷新 ===========')
      this.loaded()
    }
  }

  monitorH5(res) {
    const urlHashHandler = new UrlHashHandler(location.href)
    if (urlHashHandler.exist()) {
      const type = urlHashHandler.get()
      urlHashHandler.clear()
      // 直接设置，会触发浏览器刷新
      // location.href = urlHashHandler.getUrl();
      // 会在URL末尾加个#；这里有个副作用，会把原来的URL中的hash丢掉，不过问题不大
      location.hash = ''
      if (type === TYPES.LOGIN) {
        this.afterLogin(res)
      } else {
        this.afterLogout()
      }
    } else {
      console.log('=========== 普通刷新 ===========')
      this.loaded()
    }
  }
}

const passportMonitor = new PassportMonitor()

// 监听PC登录逻辑
window.addEventListener('load', () => {
  passportMonitor.monitor()
})

// 监听H5登录逻辑
emitter.on('h5-login', res => {
  passportMonitor.monitorH5(res)
})

emitter.on('h5-logout', () => {
  passportMonitor.monitorH5()
})

export default passportMonitor
